import { render, staticRenderFns } from "./sales_by_product_synthetic_index.vue?vue&type=template&id=84726814&scoped=true&"
import script from "./sales_by_product_synthetic_index.vue?vue&type=script&lang=js&"
export * from "./sales_by_product_synthetic_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84726814",
  null
  
)

export default component.exports